import {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Form, Row} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';

import _ from 'lodash';
import PersonDataForm from '../speaker/PersonDataForm';
import {Field} from 'formik';
import {api} from '../api';
import I18nText from '../i18n/I18nText';
import {createAccountUrl, loadUserProfile} from '../auth';

/**
 * Dient der Anzeige von Informationen zum Referenten.
 */
class Speaker extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        loadUserProfile().then(userProfile => {
            this.setState({userProfile});
        });

        if (this.props.changeSubmitterDataEnabled) {
            this.preFillSubmitterPersonData();
        }
    }

    componentWillUnmount() {
        clearInterval(this.profileRefresh);
    }

    /**
     * Füllt das Submitter-Formular mit Daten aus der Personendatenbank
     */
    preFillSubmitterPersonData() {
        api.fetchSelf().then(res => {
            const mainContact = this.props.formik.values.widgets[this.props.widgetId].submitter.mainContact;
            for (const key of Object.keys(mainContact)) {
                const field = `widgets.${this.props.widgetId}.submitter.mainContact.${key}`;
                this.props.formik.setFieldValue(field, res.mainContact[key] || '');
            }

            const pcoPersonData = this.props.formik.values.widgets[this.props.widgetId].submitter.pcoPersonData;
            for (const key of Object.keys(pcoPersonData)) {
                const field = `widgets.${this.props.widgetId}.submitter.pcoPersonData.${key}`;
                this.props.formik.setFieldValue(field, res.pcoPersonData[key] || '');
            }
        });
    }

    /**
     * Gibt anhand des übergebenen keys ein Property aus dem Keycloak-User-Objekt zurück
     *
     * @param valueName
     * @returns {any}
     */
    getProfilePropertyValue(valueName) {
        return _.get(this.state.userProfile, valueName);
    }

    render() {
        return (
            <Row data-testid={this.props.dataTestId}>
                <Col>
                    <p>
                        <I18nText content={this.props.description}/>
                    </p>
                    <small className="text-muted">
                        <FormattedMessage id="submission.form.speaker.profile.hint"/>&nbsp;
                        <a href={createAccountUrl()} target="_blank" rel="noopener noreferrer">
                            <FormattedMessage id="submission.form.speaker.profile.link"/>
                        </a>
                    </small>

                    <address>
                        {/* Derzeit wird die Anrede aus der Personen-DB im Formular angezeigt.
                          * Perspektivisch soll sie aus KeyCloak kommen und read-only dargestellt
                          * werden. Siehe auch:
                          * https://jira.leipziger-messe.de/browse/W2-1116?focusedCommentId=35850
                          */}
                        <strong>
                            {this.getProfilePropertyValue('firstName')}&nbsp;
                            {this.getProfilePropertyValue('lastName')}<br/>
                        </strong>
                        {this.getProfilePropertyValue('email')}
                    </address>

                    {/* Angaben zum Einreichenden */}
                    {
                        this.props.changeSubmitterDataEnabled && <>
                            <small className="text-muted">
                                <FormattedMessage id="submission.form.speaker.person.hint"/>&nbsp;
                            </small>

                            <PersonDataForm
                                personPath={`widgets.${this.props.widgetId}.submitter`}
                                personDataConfig={this.props.submitter}/>
                        </>
                    }

                    {/* Aktivierung eines alternativen Referenten */}
                    {
                        this.props.alternativeSpeakerEnabled &&
                        <Field name={`widgets.${this.props.widgetId}.altSpeaker`}>
                            {({field}) => (
                                <Form.Group controlId={field.name}>
                                    <Form.Check {...field}
                                                id={`widgets.${this.props.widgetId}.altSpeaker`}
                                                type="checkbox"
                                                label={<I18nText content={this.props.toggleLabel}/>}
                                                checked={field.value}
                                    />
                                </Form.Group>
                            )}
                        </Field>
                    }

                    {/* Angaben zum alternative Referenten */}
                    {
                        this.props.alternativeSpeakerEnabled
                        && this.props.formik.values.widgets[this.props.widgetId].altSpeaker
                        && <>
                            <h2>
                                <I18nText content={this.props.label}/>
                            </h2>

                            <PersonDataForm
                                personPath={`widgets.${this.props.widgetId}.speaker`}
                                personDataConfig={this.props.speaker}/>
                        </>
                    }

                </Col>
            </Row>
        );
    }
}

Speaker.propTypes = {
    toggleLabel: PropTypes.object,
    speaker: PropTypes.object,
    submitter: PropTypes.object,
    changeSubmitterDataEnabled: PropTypes.bool,
    alternativeSpeakerEnabled: PropTypes.bool,
    widgetId: PropTypes.string,
    formik: PropTypes.object
};

export default Speaker;
